<template>
  <div class="calendar-appointment-preview__container">
    <p class="appointment__section">
      <i class="icon icon-clock" />
      {{ slotDuration }} min
    </p>
    <div class="appointment__section">
      <i class="icon icon-calendar" />
      <div class="appointment__section--datetime">
        <p>{{ timeFrom }} - {{ timeTo }}</p>
        <p class="ucfirst">{{ readableDate }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    datetime: {
      type: [Date, Object, String],
      required: false,
    },
    slotDuration: {
      type: Number,
      default: 30,
    },
  },
  computed: {
    momentDatetime() {
      return moment(this.datetime).locale('es');
    },
    timeFrom() {
      return this.momentDatetime.format('HH:mm');
    },
    timeTo() {
      return this.momentDatetime.add(this.slotDuration, 'minutes').format('HH:mm');
    },
    readableDate() {
      return this.momentDatetime.format('dddd DD [de] MMMM [de] YYYY');
    },
  },
};
</script>
